import {
  PlateEditor,
  Value,
  wrapNodes,
  WrapNodesOptions,
} from '@udecode/plate-common';

import { MyInterlinkElement } from '../../../plateTypes';
import { ELEMENT_INTERLINK } from '../createInterlinkPlugin';

export interface WrapInterlinkOptions<
  V extends Value = Value,
> extends WrapNodesOptions<V> {
  linkId: string;
  linkTitle: string;
  langId: string | undefined;
}

/** Wrap a link node with split. */
export const wrapInterlink = <V extends Value>(
  editor: PlateEditor<V>,
  { linkId, linkTitle, langId, ...options }: WrapInterlinkOptions<V>,
): void => {
  wrapNodes<MyInterlinkElement, Value>(
    editor,
    {
      type: ELEMENT_INTERLINK,
      linkId,
      linkTitle,
      langId,
      children: [],
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { split: true, ...options } as any,
  );
};
